var moment = require('moment');
var module = angular.module('octopusApp.tasks');

module.controller('TaskController', function ($scope, $timeout, $state, $stateParams, $location, $q, octopusLog, busy, octopusRepository, pageTitle, pollLoop, octopusPermissionSet) {
    var isLoading = $scope.isLoading = busy.create();
    var isLoadingEvents = $scope.isLoadingEvents = busy.create();
    var isLoadingInterrupts = $scope.isLoadingInterrupts = busy.create();
    var isLoadingArtifacts = $scope.isLoadingArtifacts = busy.create();
    var isLoadingQueue = $scope.isLoadingQueue = busy.create();
    var isSubmitting = $scope.isSubmitting = busy.create();
    var isSubmittingInterruption = $scope.isSubmittingInterruption = busy.create();
    var isLoadingPrevious = $scope.isLoadingPrevious = busy.create();
    var isLoadingProgression = $scope.isLoadingProgression = busy.create();

    var id = $stateParams["id"];
    var taskId = $stateParams["taskId"];
    var depid = $stateParams["depid"];

    $scope.task = null;
    $scope.moment = moment;
    $scope.appContext = null;
    $scope.permScope = null;

    $scope.rootNodes = [];
    $scope.tab = "summary";
    $scope.isLastRefresh = false;
    $scope.isVerbose = false;
    $scope.isTail = true;

    $scope.skipBehind = 0;
    $scope.pageQueuedTasks = pageQueuedTasks;

    $scope.changeTab = function (v) {
        $scope.tab = v;
    };


    $scope.canViewLog = false;

    $scope.toggleGap = function () {
        $scope.isTail = false;
        reload();
    };

    var loop = pollLoop.create($scope, function () {
        return reload();
    }, 1000);

    $scope.rerun = function () {
        octopusLog.log("Re-running: " + $scope.task.Id);
        isSubmitting.promise(octopusRepository.Tasks.rerun($scope.task).then(function (newTask) {
            $location.path("/tasks/" + newTask.Id);
        }));
    };

    $scope.cancel = function () {
        octopusLog.log("Canceling: " + $scope.task.Id);
        isSubmitting.promise(octopusRepository.Tasks.cancel($scope.task).then(function () {
            reload();
        }));
    };

    $scope.goToLog = function (e) {
        if (!$scope.canViewLog) {
            return;
        }
        $scope.changeTab("log");
        $scope.setExpanderMode('Custom');
        $scope.nodeExpandTo(e);
        //$scope.rootNode.expander.setMode('Custom');
        //$scope.rootNode.expandTo(e);
    };

    $scope.goToLogById = function (id) {
        if (!$scope.canViewLog) {
            return;
        }
        $scope.changeTab("log");
        $scope.setExpanderMode('Custom');
        $scope.nodeExpandToId(id);
        //$scope.rootNode.expander.setMode('Custom');
        //$scope.rootNode.expandToId(id);
    };

    $scope.expanderMode = null;
    $scope.setExpanderMode = function (mode) {
        $scope.expanderMode = mode;

        _.each($scope.rootNodes, function (rootNode) {
            rootNode.expander.setMode(mode);
        });
    };
    $scope.nodeExpandTo = function (node) {
        _.each($scope.rootNodes, function (rootNode) {
            rootNode.expandTo(node);
        });
    };
    $scope.nodeExpandToId = function (nodeId) {
        _.each($scope.rootNodes, function (rootNode) {
            rootNode.expandToId(nodeId);
        });
    };

    $scope.showVerbose = function () {
        if (!$scope.canViewLog) {
            return;
        }
        $scope.isVerbose = true;
        reload();
    };

    $scope.submitInterruption = function (interrupt, result) {
        isSubmittingInterruption.promise(octopusRepository.Interruptions.submit(interrupt, result).then(function () {
            reload();
        }));
    };

    $scope.takeResponsibility = function (interrupt) {
        isSubmittingInterruption.promise(octopusRepository.Interruptions.takeResponsibility(interrupt).then(function () {
            reload();
        }));
    };

    $scope.showMachine = function (machine) {
        $location.path('/machines/' + machine.Id);
    };


    function init() {
        if (taskId) {
            var taskAsync = !!$stateParams.task ? $q.resolve($stateParams.task) : octopusRepository.Tasks.get(taskId);
            isLoading.promise(taskAsync.then(function (task) {
                if (task.Name === 'Deploy' && task.Arguments.DeploymentId) {
                    $location.path('/deployments/' + task.Arguments.DeploymentId);
                    $location.replace();
                } else {
                    $scope.task = task;
                    if (task.Arguments && task.Arguments.EnvironmentId) {
                        $scope.permScope = {environmentId: task.Arguments.EnvironmentId};
                    }
                    loop.startImmediately();
                }
            }));
        } else if (depid) {
            $scope.appContext = {};
            $scope.packages = [];

            isLoading.promise(octopusRepository.Deployments.get(depid).then(function (deployment) {
                $scope.appContext.deployment = deployment;
                $scope.permScope = {
                    projectId: deployment.ProjectId,
                    environmentId: deployment.EnvironmentId
                };

                var deploymentQueries = [
                    octopusRepository.Releases.get(deployment.ReleaseId),
                    octopusRepository.Projects.get(deployment.ProjectId),
                    octopusRepository.Channels.get(deployment.ChannelId),
                    octopusRepository.Tasks.get(deployment.TaskId),
                    octopusRepository.Environments.all()
                ];

                return $q.all(deploymentQueries).then(function (result) {
                    $scope.appContext.release = result[0];
                    $scope.appContext.project = result[1];
                    $scope.channel = result[2];
                    $scope.task = result[3];
                    $scope.appContext.environments = result[4];
                    loop.startImmediately();
                });
            }));
        }
    }

    function checkLoadingLoopComplete(details) {
        if (details.Task && (details.Task.State === "Success" || details.Task.State === "Failed" || details.Task.State === "TimedOut" || details.Task.State === "Canceled")) {
            if ($scope.isLastRefresh) {
                octopusLog.log("Task has finished; no more refreshing");
                loop.stop();
            } else {
                if ($scope.appContext && $scope.appContext.release) {
                    isLoadingProgression.promise(octopusRepository.Releases.progression($scope.appContext.release)).then(function (progression) {
                        $scope.appContext.progression = progression;
                    });
                }

                octopusLog.log("Task has finished; there will be one more refresh");
                $scope.isLastRefresh = true;
            }
        }
    }

    function reload() {
        var environmentId = $scope.permScope ? $scope.permScope.environmentId : null;
        var projectId = $scope.permScope ? $scope.permScope.projectId : null;

        octopusPermissionSet.isAuthorized({
            permission: 'TaskViewLog',
            projectId: projectId,
            environmentId: environmentId
        }).then(function (yn) {
            $scope.canViewLog = yn;
        });

        var taskDetailOptions = {
            verbose: $scope.isVerbose
        };
        if ($scope.isTail) {
            taskDetailOptions.tail = 20;
        }

        var all = [
            isLoading.promise(octopusRepository.Tasks.getDetails($scope.task, taskDetailOptions)),

            isLoadingArtifacts.promise(octopusPermissionSet.isAuthorized({
                permission: 'ArtifactView',
                projectId: projectId,
                environmentId: environmentId
            }).then(function (yn) {
                return yn ? octopusRepository.Artifacts.list({
                    regarding: $scope.task.Id,
                    skip: ($scope.artifacts && $scope.artifacts.Page > 0) ? $scope.artifacts.Page * $scope.artifacts.ItemsPerPage : 0
                }) : null;
            })),

            isLoadingInterrupts.promise(octopusPermissionSet.isAuthorized({
                permission: 'InterruptionViewSubmitResponsible',
                projectId: projectId,
                environmentId: environmentId
            }).then(function (yn) {
                return yn ? octopusRepository.Interruptions.list({regarding: $scope.task.Id}) : null;
            })),

            isLoadingEvents.promise(octopusPermissionSet.isAuthorized({
                permission: 'EventView',
                projectId: projectId,
                environmentId: environmentId
            }).then(function (yn) {
                return yn ? octopusRepository.Events.list({
                    regardingAny: (depid ? [$scope.task.Id, depid] : [$scope.task.Id]),
                    skip: ($scope.events && $scope.events.Page > 0) ? $scope.events.Page * $scope.events.ItemsPerPage : 0
                }) : null;
            }))
        ];

        if (depid) {
            all.push(isLoadingPrevious.promise(octopusRepository.Deployments.list({
                projects: projectId,
                environments: environmentId,
                taskState: 'Success',
                skip: ($scope.previous && $scope.previous.Page > 0) ? $scope.previous.Page * $scope.previous.ItemsPerPage : 0,
                take: 4
            }).then(function (previous) {
                previous.Items = _.filter(previous.Items, function (pd) {
                    return pd.Id !== depid;
                });
                if (previous.Items.Length === 4) {
                    previous.Items.Length = 3;
                }
                return previous;
            })));
        }

        return $q.all(all).then(function (result) {
            var details = result[0],
                artifacts = result[1],
                interruptions = result[2],
                events = result[3],
                previous = result[4];

            $scope.task = details.Task;
            $scope.details = details;
            $scope.progress = details.Progress;
            $scope.interruptions = interruptions;

            mergeListData($scope.artifacts, artifacts, function () {
                $scope.artifacts = artifacts;
            });

            mergeListData($scope.events, events, function () {
                $scope.events = events;
            });

            mergeListData($scope.previous, previous, function () {
                $scope.previous = previous;
            });

            if (!$scope.task.HasBeenPickedUpByProcessor) {
                loadQueuedTasks();
            } else {
                $scope.behind = [];
            }

            pageTitle(details.Task.Description);
            rebuildTree(details.ActivityLogs);
            checkLoadingLoopComplete(details);
        });
    }

    function mergeListData(scopeList, newList, initializeCallback) {
        if (scopeList) {
            scopeList.Items = newList.Items;
            scopeList.Links = newList.Links;
            scopeList.IsStale = newList.IsStale;
            scopeList.ItemsPerPage = newList.ItemsPerPage;
            scopeList.TotalResults = newList.TotalResults;
        }
        else {
            initializeCallback();
        }
    }

    function pageQueuedTasks(skipBehind) {
        $scope.skipBehind = skipBehind;
        loadQueuedTasks();
    }

    function loadQueuedTasks() {
        isLoadingQueue.promise(octopusRepository.Tasks.getQueuedBehind($scope.task, {skip: $scope.skipBehind}).then(function (behind) {
            $scope.behind = behind;
        }));
    }

    function rebuildTree(activityLogs) {
        if (!activityLogs || activityLogs.length === 0) {
            return;
        }

        _.each(activityLogs, function (activityLog) {
            var existing = _.find($scope.rootNodes, function (node) {
                return node.id === activityLog.Id &&
                    node.started === activityLog.Started &&
                    node.name === activityLog.Name;
            });
            if (!existing) {
                existing = new Octopus.Model.LogTreeNode();
                $scope.rootNodes.push(existing);
            }
            existing.refresh(activityLog);
        });
    }

    init();
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/tasks/controllers/task_controller.js
// module id = 612
// module chunks = 1